/* eslint-disable no-shadow */
(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeCardActivityCtrl', PropriedadeCardActivity);

  PropriedadeCardActivity.$inject = [
    '$window',
    'LoadingService',
    'OperacoesService',
    'OperacoesDadosService',
    '$scope',
    '$templateCache',
    'MessagesService',
    '$q',
    '$routeParams'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function PropriedadeCardActivity($window, LoadingService, OperacoesService,
    OperacoesDadosService, $scope, $templateCache, MessagesService, $q, $routeParams) {
    const NO_CONTENT = [
      'stand',
      'recomendacao',
      'aplicacao',
      'tarefa',
      'produtividade',
      'recomendacao_semeadura',
      'aplicacao_semeadura',
      'recomendacao_operacao_adubacao',
      'recomendacao_operacao_correcao_solo',
      'operacao_correcao_solo',
      'operacao_adubacao',
      'tratamento_semente'
    ];
    const vm = this;
    let cards = null;

    //////////////////////////////////////////
    // Controller data
    vm.initialized = false;
    vm.data = null;
    vm.cardDataType = null;

    //////////////////////////////////////////
    // Bindable methods
    vm.init = init;
    vm.iconClasses = iconClasses; // empty, defined on init
    vm.hasItemActive = hasItemActive; // empty, defined on init
    vm.activityHasContent = activityHasContent;
    vm.activateActivity = activateActivity;
    vm.activateNotification = activateNotification;
    vm.activateStandSummary = activateStandSummary;
    vm.activateProductivitySummary = activateProductivitySummary;
    vm.hasOcorrencias = hasOcorrencias;
    vm.ocorrenciaClassName = ocorrenciaClassName;
    vm.isTratamentoSemente = isTratamentoSemente;

    //////////////////////////////////////////
    // Function declarations

    function init(propriedadeCards) {
      cards = propriedadeCards;
      vm.initialized = true;
    }

    function iconClasses(item) {
      return cards ? cards.iconClasses(item) : null;
    }

    function hasItemActive(items) {
      return cards ? cards.hasItemActive(items) : false;
    }

    function hasOcorrencias() {
      const keys = Object.keys(vm.data || {});
      return TIPOS_OPERACAO_OCORRENCIAS.concat(TIPOS_OUTRAS_OCORRENCIAS).some((key) => keys.includes(key));
    }

    function ocorrenciaClassName(type) {
      return `hist-ocorrencia-type-${type}`;
    }

    function isTratamentoSemente(activity) {
      const notificacoes = activity.notificacoes || [];
      return notificacoes.length > 0 &&
        notificacoes.every((notification) => notification.tipo === 'tratamento_semente');
    }

    function activityHasContent(activity) {
      const active = _.find(activity.notificacoes, 'active');
      return active && NO_CONTENT.indexOf(active.tipo) === -1;
    }

    function genericError() {
      MessagesService.alert('Falha ao carregar dados, tente novamente mais tarde.');
    }

    function showAllMarkers() {
      $scope.$emit('setMarkers', Object.values(vm.data || {}).reduce((group, data) => group.concat(data), []));
    }

    /*
     * Interactions
     */
    function activateActivity(activity) {
      cards.activate('activity', { activity });
      loadAndShowMarkers(activity);
    }

    function activateNotification(notification, activity) {
      if (notification.tipo === 'recomendacao_semeadura') {
        return $window.open('#!/recomendacoes_semeadura', '_blank');
      } else if (notification.tipo === 'aplicacao_semeadura' && notification.representado_type !== 'Aplicacao') {
        return $window.open(`#!/plantios?gleba=${activity.gleba.id}&safra=${activity.safra.id}`, '_blank');
      }
      resetMarkers();
      if (notification.active) {
        cards.activate('activity', { activity });
        return activateActivity(activity);
      }

      return loadAndReact(notification, activity).then(() => {
        cards.activate('notification', {
          activity,
          notification,
          data: vm.data
        });

        checkNotificationType(notification);

        if (!notification.active && activity.active) {
          showAllMarkers();
        }
      });
    }

    // eslint-disable-next-line complexity
    function checkNotificationType(notification) {
      if (notification.tipo === 'inseto') {
        showInsectData(notification);
      } else if (notification.tipo === 'anotacao') {
        showNotesData(notification);
      } else if (notification.tipo === 'invasora') {
        showInvasoraData(notification);
      } else if (notification.tipo === 'doenca') {
        showDoencaData(notification);
      } else if (notification.tipo === 'nematoide') {
        showNematoideData(notification);
      } else if (notification.tipo === 'inimigo_natural') {
        showInimigoNaturalData(notification);
      } else if (notification.tipo.includes('afericao')) {
        showGenericData(notification);
      } else if (TIPOS_OUTRAS_OCORRENCIAS.includes(notification.tipo)) {
        showGenericData(notification);
      }
    }

    function loadAndReact(notification, activity) {
      return loadActivityData(activity).then(() => {
        if (notification.tipo === 'tarefa') {
          activateTarefas(activity);
          return true;
        }
      });
    }

    function activateStandSummary(stand, activity) {
      resetMarkers();
      if (stand.active) {
        return activateActivity(activity);
      }
      return loadActivityData(activity).then(() => {
        cards.activate('standSummary', { activity, stand, data: vm.data });
        if (!stand.active && activity.active) {
          showAllMarkers();
        }
      });
    }

    function activateProductivitySummary(productivity, activity) {
      resetMarkers();
      if (productivity.active) {
        return activateActivity(activity);
      }
      return loadActivityData(activity).then(() => {
        cards.activate('produtividadeSummary', { activity, productivity, data: vm.data });
        if (!productivity.active && activity.active) {
          showAllMarkers();
        }
      });
    }

    function activateTarefas(activity) {
      cards.activate('tasks', { activity });
    }

    function loadAndShowMarkers(activity) {
      if (activity.active) {
        loadActivityData(activity).then(showAllMarkers);
      } else {
        resetMarkers();
      }
    }

    /*
     * Card data
     */
    function loadActivityData(activity) {
      if (!vm.data) {
        LoadingService.showLoading();

        const filters = {
          gleba: { id: activity.gleba.id },
          dia: activity.data,
          usuario: ($scope.filters.usuario || {}).id,
          tipo: ($scope.filters.operacao || {}).id,
          ocorrencia: ($scope.filters.ocorrencia || {}).id
        };

        const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');
        return OperacoesService.getOperationsDayGleba(filters).then((result) => {
          vm.data = OperacoesDadosService.newGetMarkersOperationsDayGleba(
            result.data, null, template
          ).reduce(function(result, record) {
            result[record.marker.tipo] = result[record.marker.tipo] || [];
            result[record.marker.tipo].push(record);
            return result;
          }, {});
        }, genericError)
          .finally(LoadingService.hideLoading);
      }
      return $q.resolve();
    }

    function showData(type, notification) {
      if (notification.active && vm.data[type]) {
        vm.cardDataType = type;

        if (type === notification.tipo) {
          return $scope.$emit('setMarkers', vm.data[type]);
        }
      }
      showAllMarkers();
    }

    function showInsectData(notification) {
      showData('inseto', notification);
    }

    function showNotesData(notification) {
      showData('anotacao', notification);
    }

    function showInvasoraData(notification) {
      showData('invasora', notification);
    }

    function showDoencaData(notification) {
      showData('doenca', notification);
    }

    function showNematoideData(notification) {
      showData('nematoide', notification);
    }

    function showInimigoNaturalData(notification) {
      showData('inimigo_natural', notification);
    }

    function showGenericData(notification) {
      showData(notification.tipo, notification);
    }

    function resetMarkers() {
      $scope.$emit('setMarkers', []);
    }

    //////////////////////////////////////////
    // Controller logic

    const watcher = $scope.$watch('card.initialized', () => {
      if (vm.initialized) {
        watcher(); // stop watching

        if ($routeParams.activeGleba && +$routeParams.activeGleba === $scope.activity.gleba.id) {
          if ($routeParams.produtividadeSummary) {
            const produtividade = $scope.activity.gerais.produtividade[$routeParams.produtividadeSummary];
            return activateProductivitySummary(produtividade, $scope.activity);
          } else if ($routeParams.standSummary) {
            const stand = $scope.activity.gerais.stand[$routeParams.standSummary];
            return activateStandSummary(stand, $scope.activity);
          } else if ($routeParams.notification) {
            const notification = _.find($scope.activity.notificacoes, { tipo: $routeParams.notification });
            return activateNotification(notification, $scope.activity);
          }
          return activateActivity($scope.activity);
        }
      }
    });
  }
}());
